export const prerender = true;
// No localStorage access on this page — SSR is fine, but we keep it
// consistent with the rest of the app.
export const ssr = false;
